module.exports = __webpack_public_path__ + "static/media/Heavyrain.13d0e10d.png";